import ReactDOM from "react-dom/client";
import App from "./App";
import { QueryClient, QueryClientProvider } from "react-query";
import { useEffect } from "react";
import useGlobal from "./logic/hooks/useGlobal";
import "./styles/globals.css";


const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
  );

const queryClient = new QueryClient();

const MyApp = () => {

  const [colorMode = "dark" , setColorMode ] = useGlobal<'dark' | 'light'>(["colormode", "selected"]);

  useEffect(() => {
    const queryParameters = new URLSearchParams(
      window?.location?.href.split("?")[1]
    );
  
    const base64Decoded = queryParameters.get("data") || "";
  
    if (base64Decoded) {
      const jsonDecoded = atob(base64Decoded);
      const decodedObject = JSON.parse(jsonDecoded);

      if (decodedObject?.appTheme) {
        setColorMode(decodedObject?.appTheme);
      } else {
        setColorMode('dark');
      }
    } else {
      setColorMode('dark');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', colorMode);
    document.documentElement.style.colorScheme = colorMode;
    document.documentElement.classList.toggle('dark', colorMode === 'dark');
    document.documentElement.classList.toggle('light', colorMode === 'light');
  }, [colorMode]);

  return (
    <QueryClientProvider client={queryClient}>
          <App />
     </QueryClientProvider>
  );
}

root.render(<MyApp />);
